import { PullQuote as UniformPullQuote } from '@/libraries/design/components/pull-quote/src/pull-quote.tsx';

import { GlobalFooter as UniformGlobalFooter } from '../patterns/global-footer/src/global-footer.tsx';

import UniformAccordion from './components/accordion/src/accordion.tsx';
import UniformAccordionsSection from './components/accordions-section/src/accordions-section.tsx';
import UniformAnimationWrapper from './components/animation-wrapper/src/animation-wrapper.tsx';
import UniformArticleCta from './components/article-cta/src/article-cta.tsx';
import UniformBackgroundVideoContainer from './components/background-video-container/src/background-video-container.tsx';
import UniformBannerAlert from './components/banner-alert/src/banner-alert.tsx';
import UniformBitbucketSearchIntegration from './components/bitbucket-search-integration/src/bitbucket-search-integration.tsx';
import UniformBleedingImageHero from './components/bleeding-image-hero/src/bleeding-image-hero.tsx';
import UniformBlogNewsGallery from './components/blog-news-gallery/src/blog-news-gallery.tsx';
import UniformBodyContent from './components/body-content/src/body-content.tsx';
import UniformBodyContentV1 from './components/body-content-v1/src/index.tsx';
import UniformBreadcrumbLink from './components/breadcrumbs/src/uniform-breadcrumb-link';
import UniformBreadcrumbs from './components/breadcrumbs/src/uniform-breadcrumbs';
import UniformButton from './components/button/src/button.tsx';
import UniformCallToAction from './components/call-to-action/src/call-to-action.tsx';
import UniformCard from './components/card/src/card.tsx';
import UniformCareersGallery from './components/careers-gallery/src/careers-gallery.tsx';
import UniformCollectionPricingHero from './components/collection-pricing-hero/src/collection-pricing-hero.tsx';
import {
	UniformColumnLayout,
	UniformSubColumnLayout,
} from './components/column-layout/src/column-layout.tsx';
import UniformCompanyTimeline from './components/company-timeline/src/company-timeline.tsx';
import UniformConfluenceAnimatedHero from './components/confluence-animated-hero/src/confluence-animated-hero.tsx';
import UniformConnector from './components/connector/src/connector.tsx';
import UniformContainer from './components/container/src/container.tsx';
import UniformContentBlock from './components/content-block/src/content-block.tsx';
import UniformContentfulGalleryContainer from './components/contentful-gallery-container/src/contentful-gallery-container';
import UniformContextualBanditsContainer from './components/contextual-bandits-container/src/contextual-bandits-container.tsx';
import UniformContextualBanditsVariant from './components/contextual-bandits-variant/src/contextual-bandits-variant.tsx';
import UniformCopyText from './components/copy-text/src/uniform-copy-text.tsx';
import UniformCustomTableCell from './components/custom-table-cell/src/custom-table-cell';
import UniformCustomerGallery from './components/customer-gallery/src/customer-gallery.tsx';
import UniformCustomerStat from './components/customer-stat/src/customer-stat.tsx';
import UniformCustomerStoriesDetailsHero from './components/customer-stories-details-hero/src/customer-stories-details-hero.tsx';
import UniformCustomerTestimonials from './components/customer-testimonials/src/customer-testimonials.tsx';
import UniformDecorativeContainer from './components/decorative-container/src/decorative-container.tsx';
import UniformDesignRefreshBar from './components/design-refresh-bar/src/design-refresh-bar.tsx';
import UniformDesignRefreshHeading from './components/design-refresh-heading/src/design-refresh-heading.tsx';
import UniformDivider from './components/divider/src/divider.tsx';
import UniformDownloadArchives from './components/download-archives/src/download-archives';
import UniformDownloadRow from './components/download-row/src/download-row.tsx';
import UniformDownloadTable from './components/download-table/src/download-table.tsx';
import UniformEmailSubscriptionForm from './components/email-subscription-form/src/email-subscription-form';
import UniformEmbeddedVideo from './components/embedded-video/src/embedded-video.tsx';
import UniformEnhancedBanner from './components/enhanced-banner/src/enhanced-banner.tsx';
import UniformExpand from './components/expand/src/expand';
import UniformExperiment from './components/experiment/src/experiment.tsx';
import UniformFeatureGate from './components/feature-gate/src/feature-gate.tsx';
import UniformFeaturesHighlight from './components/features-highlight/src/features-highlight.tsx';
import UniformFilterableCard from './components/filterable-card/src/filterable-card';
import UniformFilterableGallery from './components/filterable-gallery/src/filterable-gallery.tsx';
import UniformFilterableItem from './components/filterable-item';
import UniformFormStructuralComponent from './components/form/src/uniform-form-structural-component.tsx';
import UniformForm from './components/form/src/uniform-form.tsx';
import UniformGlobalNav from './components/global-nav/src/global-nav.tsx';
import UniformGraphPaperReveal from './components/graph-paper-reveal/src/graph-paper-reveal.tsx';
import UniformHeading from './components/heading/src/heading.tsx';
import UniformHeroCarousel from './components/hero-carousel/src/hero-carousel.tsx';
import UniformHeroScrollContainer from './components/hero-scroll-container/src/hero-scroll-container.tsx';
import UniformHeroSection from './components/hero-section/src/uniform-hero-section.tsx';
import UniformHoveringTeamworkGraph from './components/hovering-teamwork-graph/src/hovering-teamwork-graph';
import UniformImage from './components/image/src/image.tsx';
import UniformImageV2 from './components/image-v2/src/image-v2.tsx';
import UniformIntegration from './components/integration/src/integration.tsx';
import UniformInvisibleContent from './components/invisible-content/src/invisible-content.tsx';
import { JiraAjAnimatedHero } from './components/jira-aj-animated-hero/src/jira-aj-animated-hero';
import UniformJiraTemplatesTabContentSubgridLayout from './components/jira-templates-tab-content-subgrid-layout/src/jira-templates-tab-content-subgrid-layout.tsx';
import UniformJobPostingSubheading from './components/job-posting-subheading/src/job-posting-subheading.tsx';
import UniformJsmPortalPlayground from './components/jsm-portal-playground/src/uniform-jsm-portal-playground.tsx';
import UniformLink from './components/link/src/link.tsx';
import UniformListV2 from './components/list-v2/src/listv2.tsx';
import UniformLoggedInHeroSection from './components/logged-in-hero-section/src/index.tsx';
import UniformLogos from './components/logos/src/logos.tsx';
import UniformLozenge from './components/lozenge/src/lozenge.tsx';
import UniformMarketoForm from './components/marketo-form/src/marketo-form.tsx';
import UniformMigrationPlaceholder from './components/migration-placeholder/src/migration-placeholder.tsx';
import UniformMobileApp from './components/mobile-app/src/mobile-app.tsx';
import UniformModal from './components/modal/src/modal.tsx';
import UniformNavBar from './components/nav-bar/src/nav-bar.tsx';
import UniformNavigationTab from './components/navigation-tab/src/uniform-navigation-tab';
import UniformNavigationTabs from './components/navigation-tabs/src/uniform-navigation-tabs';
import UniformPage from './components/page/src/page.tsx';
import UniformPagination from './components/pagination/src/pagination.tsx';
import UniformPanel from './components/panel/src/panel.tsx';
import UniformPersonalizationContainer from './components/personalization-container/src/personalization-container.tsx';
import UniformPixelIcon from './components/pixel-icon/src/pixel-icon.tsx';
import UniformPixelRepelGrid from './components/pixel-repel-grid/src/pixel-repel-grid.tsx';
import UniformPolygonCallToAction from './components/polygon-call-to-action/src/polygon-call-to-action.tsx';
import UniformPricingCalculator from './components/pricing-calculator/src/price-calculator.tsx';
import UniformPricingTable from './components/pricing-table/src/pricing-table.tsx';
import UniformPricingTiersTable from './components/pricing-tiers-table/src/pricing-tiers-table.tsx';
import UniformProductCard from './components/product-card/src/product-card.tsx';
import UniformProductCardBlock from './components/product-card-block/src/product-card-block.tsx';
import UniformPromptBlock from './components/prompt-block/src/uniform-prompt-block.tsx';
import UniformReturnToProduct from './components/return-to-product/src/return-to-product.tsx';
import UniformRoadmapFeatures from './components/roadmap-features/src/roadmap-features.tsx';
import UniformRovoChatBox from './components/rovo-chat-box/src/rovo-chat-box.tsx';
import UniformRovoChatContainer from './components/rovo-chat-container/src/rovo-chat-container.tsx';
import UniformRovoChatHeader from './components/rovo-chat-header/src/rovo-chat-header.tsx';
import UniformRovoHero from './components/rovo-hero/src/rovo-hero.tsx';
import UniformScrollableHeroCards from './components/scrollable-cards/src/scrollable-cards.tsx';
import UniformSideNav from './components/side-nav/src/side-nav';
import UniformSideNavCollection from './components/side-nav-collection/src/side-nav-collection.tsx';
import UniformSideNavLink from './components/side-nav-link/src/side-nav-link.tsx';
import UniformSignUpForm from './components/sign-up-form/src/sign-up-form.tsx';
import UniformSimpleTableCell from './components/simple-table-cell/src/simple-table-cell';
import UniformSingleStat from './components/single-stat/src/single-stat';
import UniformSingleTab from './components/single-tab/src/single-tab.tsx';
import UniformSkeleton from './components/skeleton/src/skeleton.tsx';
import UniformSlidingLayout from './components/sliding-layout/src/sliding-layout.tsx';
import UniformSpeakers from './components/speakers/src/speakers.tsx';
import UniformSplitColorBackgroundContainer from './components/split-color-background-container/src/split-color-background-container.tsx';
import UniformStaticPricingCards from './components/static-pricing-cards/src/static-pricing-cards';
import { UniformStatsSection } from './components/stats-section/src/stats-section.tsx';
import UniformsubProduct from './components/sub-product/src/sub-product.tsx';
import UniformTable from './components/table/src/table';
import UniformTableColumnHeader from './components/table-header-cell/src/table-column-header';
import UniformTableHeaderRow from './components/table-header-row/src/table-header-row';
import UniformTableRow from './components/table-row/src/table-row';
import UniformTabs12Col from './components/tabs-12-col/src/tabs-12-col.tsx';
import UniformTabs8Col from './components/tabs-8-col/src/tabs-8-col.tsx';
import UniformTakeoverBanner from './components/takeover-banner/src/takeover-banner';
import UniformTeamworkGraph from './components/teamwork-graph/src/teamwork-graph.tsx';
import UniformTemplateModalButton from './components/template-modal-button/src/template-modal-button.tsx';
import UniformTemplatePreview from './components/template-preview/src/template-preview.tsx';
import UniformTemplatesSearchBar from './components/templates-search-bar';
import UniformTerminalTyping from './components/terminal-typing/src/terminal-typing.tsx';
import UniformText from './components/text/src/text.tsx';
import UniformTextWithIcon from './components/text-with-icon/src/text-with-icon.tsx';
import UniformThirdPartyEmbed from './components/third-party-embed/src/third-party-embed.tsx';
import UniformValueProps from './components/value-props/src/value-props.tsx';
import UniformVariant from './components/variant/src/variant.tsx';
import UniformVariantContainer from './components/variant-container/src/variant-container.tsx';
import UniformVideo from './components/video/src/video.tsx';
import UniformVideoCarousel from './components/video-carousel/src/video-carousel.tsx';
import UniformWebinarButton from './components/webinar-button/src/webinar-button';
import UniformWebinarForm from './components/webinar-form/src/webinar-form.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const UNIFORM_DEFINITIONS: Record<string, any> = {
	accordion: UniformAccordion,
	accordionsSection: UniformAccordionsSection,
	animationWrapper: UniformAnimationWrapper,
	articleCta: UniformArticleCta,
	backgroundVideoContainer: UniformBackgroundVideoContainer,
	bannerAlert: UniformBannerAlert,
	bitbucketSearchIntegration: UniformBitbucketSearchIntegration,
	bleedingImageHero: UniformBleedingImageHero,
	blockContainer: UniformContainer,
	blogNewsGallery: UniformBlogNewsGallery,
	bodyContent: UniformBodyContent,
	button: UniformButton,
	callToAction: UniformCallToAction,
	card: UniformCard,
	careersGallery: UniformCareersGallery,
	collectionPricingHero: UniformCollectionPricingHero,
	columnLayout: UniformColumnLayout,
	companyTimeline: UniformCompanyTimeline,
	confluenceAnimatedHero: UniformConfluenceAnimatedHero,
	connector: UniformConnector,
	contentBlock: UniformContentBlock,
	promptBlock: UniformPromptBlock,
	copyText: UniformCopyText,
	contextualBanditsContainer: UniformContextualBanditsContainer,
	contextualBanditsVariant: UniformContextualBanditsVariant,
	ctaWithPolygonBackground: UniformPolygonCallToAction,
	customTableCell: UniformCustomTableCell,
	customerBodyContent: UniformBodyContentV1,
	customerGallery: UniformCustomerGallery,
	customerStat: UniformCustomerStat,
	customerStoriesDetailsHero: UniformCustomerStoriesDetailsHero,
	customerTestimonials: UniformCustomerTestimonials,
	decorativeContainer: UniformDecorativeContainer,
	designRefreshBar: UniformDesignRefreshBar,
	designRefreshHeading: UniformDesignRefreshHeading,
	downloadArchives: UniformDownloadArchives,
	emailSubscriptionForm: UniformEmailSubscriptionForm,
	embeddedVideo: UniformEmbeddedVideo,
	enhancedBanner: UniformEnhancedBanner,
	downloadRow: UniformDownloadRow,
	downloadTable: UniformDownloadTable,
	expand: UniformExpand,
	featuresHighlight: UniformFeaturesHighlight,
	globalFooter: UniformGlobalFooter,
	globalNav: UniformGlobalNav,
	graphPaperReveal: UniformGraphPaperReveal,
	heading: UniformHeading,
	heroCarouselSection: UniformHeroCarousel,
	heroScrollToEnlargeContainer: UniformHeroScrollContainer,
	heroSection: UniformHeroSection,
	hoveringTeamworkGraph: UniformHoveringTeamworkGraph,
	// Both keys resolve to the same product-agnostic hero (product detected from
	// the URL). jsmLoggedInHeroSection is retained so existing JSM-authored pages
	// keep working; new pages should use loggedInHeroSection.
	jsmLoggedInHeroSection: UniformLoggedInHeroSection,
	loggedInHeroSection: UniformLoggedInHeroSection,
	jsmPortalPlayground: UniformJsmPortalPlayground,
	horizontalDivider: UniformDivider,
	image: UniformImage,
	imageV2: UniformImageV2,
	integration: UniformIntegration,
	invisibleContent: UniformInvisibleContent,
	navBar: UniformNavBar,
	navigationTab: UniformNavigationTab,
	navigationTabs: UniformNavigationTabs,
	pricingTiersTable: UniformPricingTiersTable,
	productCardBlock: UniformProductCardBlock,
	returnToProduct: UniformReturnToProduct,
	roadmapFeatures: UniformRoadmapFeatures,
	rovoChatContainer: UniformRovoChatContainer,
	rovoChatBox: UniformRovoChatBox,
	rovoChatHeader: UniformRovoChatHeader,
	scrollableHeroCards: UniformScrollableHeroCards,
	filterableGallery: UniformFilterableGallery,
	filterableItem: UniformFilterableItem,
	form: UniformForm,
	formCompanyField: UniformFormStructuralComponent,
	formCustomChoiceField: UniformFormStructuralComponent,
	formCustomTextField: UniformFormStructuralComponent,
	formEmailField: UniformFormStructuralComponent,
	formNamesFields: UniformFormStructuralComponent,
	formOption: UniformFormStructuralComponent,
	formPhoneNumberField: UniformFormStructuralComponent,
	jiraAjAnimatedHero: JiraAjAnimatedHero,
	jiraTemplatesTabContentSubgridLayout: UniformJiraTemplatesTabContentSubgridLayout,
	jobPostingSubheading: UniformJobPostingSubheading,
	link: UniformLink,
	listv2: UniformListV2,
	logos: UniformLogos,
	lozenge: UniformLozenge,
	marketoForm: UniformMarketoForm,
	migrationPlaceholder: UniformMigrationPlaceholder,
	mobileApp: UniformMobileApp,
	modal: UniformModal,
	page: UniformPage,
	pagination: UniformPagination,
	panel: UniformPanel,
	personalizationContainer: UniformPersonalizationContainer,
	pixelIcon: UniformPixelIcon,
	pixelRepelGrid: UniformPixelRepelGrid,
	pricingCalculator: UniformPricingCalculator,
	pricingTable: UniformPricingTable,
	productCard: UniformProductCard,
	pullQuote: UniformPullQuote,
	rovoHero: UniformRovoHero,
	breadcrumbs: UniformBreadcrumbs,
	breadcrumbLink: UniformBreadcrumbLink,
	sideNav: UniformSideNav,
	sideNavCollection: UniformSideNavCollection,
	sideNavLink: UniformSideNavLink,
	signUpForm: UniformSignUpForm,
	simpleTableCell: UniformSimpleTableCell,
	singleStat: UniformSingleStat,
	skeleton: UniformSkeleton,
	slidingLayout: UniformSlidingLayout,
	staticPricingCards: UniformStaticPricingCards,
	subProduct: UniformsubProduct,
	singleTab: UniformSingleTab,
	speakers: UniformSpeakers,
	splitBackgroundContainer: UniformSplitColorBackgroundContainer,
	statsSection: UniformStatsSection,
	statsigExperimentContainer: UniformExperiment,
	statsigFeatureGateContainer: UniformFeatureGate,
	subColumnLayout: UniformSubColumnLayout,
	table: UniformTable,
	tableColumnHeader: UniformTableColumnHeader,
	tableHeaderRow: UniformTableHeaderRow,
	tableRow: UniformTableRow,
	tabs12Col: UniformTabs12Col,
	tabs8Col: UniformTabs8Col,
	takeoverBanner: UniformTakeoverBanner,
	teamworkGraph: UniformTeamworkGraph,
	templateModalButton: UniformTemplateModalButton,
	templatePreview: UniformTemplatePreview,
	filterableCard: UniformFilterableCard,
	contentfulGalleryContainer: UniformContentfulGalleryContainer,
	templatesSearchBar: UniformTemplatesSearchBar,
	terminalTyping: UniformTerminalTyping,
	text: UniformText,
	textWithIcon: UniformTextWithIcon,
	thirdPartyEmbed: UniformThirdPartyEmbed,
	variant: UniformVariant,
	variantContainer: UniformVariantContainer,
	valueProps: UniformValueProps,
	video: UniformVideo,
	videoCarousel: UniformVideoCarousel,
	webinarButton: UniformWebinarButton,
	webinarForm: UniformWebinarForm,
};

export default UNIFORM_DEFINITIONS;
